import axios from '@services/HTTP'
import type { CartItem } from 'store/checkout'

/** Tags tracking where an item came from stay in this browser; the shared cart must not carry them. */
const stripLocalTags = ({ reorderHash, recoveryCartHash, ...item }: CartItem) => item

export const createCart = async (data: CartItem[]) => {
  const vendor = window.location.pathname.split('/')[2]

  const response = await axios.post<{ cart_hash: string }, { cart_hash: string }>('/cart', {
    vendor_hash: vendor,
    items: data.map(stripLocalTags)
  })

  return response
}
